import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/g9vCFAypwgbYstaFQcDtXq/Mockup_-_SN14_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4lyv8luf2edn">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="1297a3xzwwp6o" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="xae5yw6imaj6">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="xb5s7ge82vws">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="3d1ik78o21amw">
          Eliminá el ardor crónico y volvé a dormir toda la noche en 21 días{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3o7lrboupx2nw">sin dejar el Omeprazol de golpe ni vivir a lechuga.</span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="39aur5dd7zmx8">
          <img src={mockupUrl} alt="Mockup del Sistema Estómago Bajo Control" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="3eb9150ydt6xw" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="2qk3k4igpg8m0">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="2vjpvemcz3es6">SISTEMA ESTÓMAGO BAJO CONTROL™</p>
          <p className="-mb-4 mt-3 text-[14px] text-slate-200 sm:text-base font-[400]" data-id="element-76" data-mp="2lkqz839e9bm2">
            El mapa práctico que tu médico no te dio. Diseñado para argentinos de +45 años que buscan recuperar el asado, el mate y la sobremesa sin miedo al ácido.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="n9qf903poc37">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="i9vqb23hxwks"><FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-79" data-mp="1b0vx1kt7peg5" />100% PDF</span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="1ayt8z6bmdve2"><ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-81" data-mp="15zq69sj44199" />Acceso en 5 min</span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="x14nbw9qak7y">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="3lui86njf0tjs">QUIERO MI SISTEMA AHORA</ActionButton>
        </motion.div>
      </div>
    </section>;
}